/* eslint-disable no-useless-escape */
import { initialDataProvider } from '@microfrontends/app-shell-v2'

export const proficiencyLevel = [
    {
        id: 1,
        name: 'Sơ Cấp',
        nameEn: 'Beginner',
        bgColor: '#f8c603'
    },
    {
        id: 2,
        name: 'Trung Cấp',
        nameEn: 'Intermediate',
        bgColor: '#FF7D55'
    },
    {
        id: 3,
        name: 'Cao Cấp',
        nameEn: 'Advanced',
        bgColor: '#005aff'
    },
    {
        id: 4,
        name: 'Bản Địa',
        nameEn: 'Native',
        bgColor: '#7ac123'
    }
]

export const proficiencySkillLevel = [
    {
        id: 1,
        name: '1',
        bgColor: '#999999'
    },
    {
        id: 2,
        name: '2',
        bgColor: '#F7BE06'
    },
    {
        id: 3,
        name: '3',
        bgColor: '#FF7D55'
    },
    {
        id: 4,
        name: '4',
        bgColor: '#005aff'
    },
    {
        id: 5,
        name: '5',
        bgColor: '#6FB920'
    }
]

export const INTERNSHIP_ID = 8
export const FRESHER_ID = 1

export const noSpecialChars: RegExp = /[-0-9#@!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/
export const noSpecialCharsButNumber: RegExp = /[#@!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/
export const noSpecialCharsForJobTitle: RegExp = /[@!$%^*()_|~=`{}\[\]:";'<>?,]/
export const numericOnly = /^-?\d*(\.\d*)?$/
export const numericAndCommaOnly = /(,*[\d]+,*[\d]*)+/
export const MAX_CHAR = 5000
export const LOCATION_LIST = initialDataProvider.getLocations()
export const LOCATION_LIST_EN = LOCATION_LIST.map((item) => ({
    id: item.id,
    name: item.nameEn
}))
export const LEVEL_LIST = initialDataProvider.getLevels()
export const LEVEL_LIST_EN = LEVEL_LIST.map((item) => ({
    id: item.id,
    name: item.nameEn
}))

export const SKILL_NAME_LIMITED_CHAR = 40
export const UNCONTACTABLE_ERROR_CODE = 'UC001'

export const LITMIT_DESCRIPTION = 5000

export const CHARACTER_LENGTH = 10.5
export const DEFAULT_MIN_WIDTH = 25
